import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

// --- Components ---
import { ImageDefaultModule } from '@components/image-default/image-default.module';

// --- Overlay Panel ---
import { AutocompleteOverlayPanelComponent } from './autocomplete-overlay-panel.component';

// --- Directives ---
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
	declarations: [AutocompleteOverlayPanelComponent],
	imports: [
		CommonModule,
		RouterModule,

		// --- PrimeNG ---
		ButtonModule,
		DividerModule,
		ProgressSpinnerModule,

		// --- Components ---
		ImageDefaultModule,

		// --- Directives ---
		DirectivesModule,
	],
	exports: [AutocompleteOverlayPanelComponent],
})
export class AutocompleteOverlayPanelModule {}
